import React from "react";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ThreatMap from "./components/ThreatMap";
import Dimensions from "./components/Dimensions";
import ExternalScan from "./components/ExternalScan";
import InternalScan from "./components/InternalScan";
import Pricing from "./components/Pricing";
import Benefits from "./components/Benefits";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-black min-h-screen">
        <Navbar />
        <Hero />
        <ThreatMap />
        <Dimensions />
        <ExternalScan />
        <InternalScan />
        <Pricing />
        <Benefits />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
